<template>
    <div class="home">
        <section class="homeNei">
            <article
                class="home_saas "
                v-if="homePicture.FirstShow"
            ><img v-lazy="homePicture.FirstPicture" /></article>
            <article
                class="home_saas "
                v-if="homePicture.SecondShow"
            ><img v-lazy="homePicture.SecondPicture" /></article>
            <article
                class="home_saas "
                v-if="homePicture.ThirdShow"
            ><img v-lazy="homePicture.ThirdPicture" /></article>
            <article
                class="home_saas "
                v-if="homePicture.FourShow"
            ><img v-lazy="homePicture.FourPicture" /></article>
            <article
                class="home_saas "
                v-if="homePicture.FiveShow"
            ><img v-lazy="homePicture.FivePicture" /></article>
            <article
                class="home_saas "
                v-if="homePicture.SixShow"
            ><img v-lazy="homePicture.SixPicture" /></article>
        </section>
        <!-- 联系客服 -->
        <aside-fixed></aside-fixed>
    </div>
</template>

<script>
import asideFixed from '@/components/global/aside/aside.vue';
export default {
    components: {
        asideFixed
    },
    name: 'home',
    data() {
        return {
            bannerList: [],
            swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            },
            homePicture: []
        };
    },
    mounted() {
        this.GetNavigation();
        // this.GetBanner();
    },
    methods: {
        callback() { },
        // 获取图片
        GetNavigation: function () {
            var that = this;
            that.$api.HtppRequest(
                'WebsiteSet/GetNavigationDetail?position=2',
                'GET', {},
                function (res) {
                    console.log('获取图片');
                    console.log(res);
                    if (res.code === 0) {
                        that.homePicture = res.data;
                    }
                },
                function (res) { }
            );
        },
        // 获取轮播图
        GetBanner: function () {
            var that = this;
            that.$api.HtppRequest(
                'WebsiteSet/GetPagePicture',
                'GET', {},
                function (res) {
                    console.log('获取轮播图');
                    console.log(res);
                    if (res.code === 0) {
                        var list = res.data;
                        var newList = [];
                        for (var i = 0; i < list.length; i++) {
                            if (list[i].Type === 1 && list[i].Position !== 4) {
                                newList.push(list[i]);
                            }
                        }
                        that.bannerList = newList;
                        that.swiper.slideTo(3, 1000, false);
                        console.log(newList);
                    }
                },
                function (res) { }
            );
        }
    }
};
</script>
<style scoped>
/* home_mei */

.home_saas img {
    display: block;
    width: 100%;
}

.home_saas {
    overflow: hidden;
}

/* home_saas */

.homeNei {
    overflow: hidden;
    width: 100%;
    margin: 0px auto 60px auto;
}

.homeNei img {
    display: block;
    width: 100%;
}

/* homeNei */

* >>> .swiper-pagination-bullet {
    width: 20px !important;
    height: 10px !important;
    border-radius: 50px;
    background-color: rgba(255, 255, 255, 0.7);
}

* >>> .swiper-pagination-bullet-active {
    background-color: #fff;
}

.banner {
    overflow: hidden;
    height: auto;
    background: url(../../image/AI-banner.png) no-repeat left top;
    background-size: 1920px 700px;
}
</style>
